/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_Teams_Delete_TitleInputs */

const cs_settings_teams_delete_title = /** @type {(inputs: Settings_Teams_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Smazat ${i?.name}?`)
};

const en_settings_teams_delete_title = /** @type {(inputs: Settings_Teams_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name}?`)
};

/**
* | output |
* | --- |
* | "Delete {name}?" |
*
* @param {Settings_Teams_Delete_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_delete_title = /** @type {((inputs: Settings_Teams_Delete_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Delete_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_delete_title(inputs)
	return cs_settings_teams_delete_title(inputs)
});